import { Component, Input } from '@angular/core';
import { LanguageService } from 'src/app/services/languageService/language.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-asset-card',
  templateUrl: './asset-card.component.html',
  styleUrls: ['./asset-card.component.less']
})
export class AssetCardComponent {
  @Input() asset;
  @Input() style;
  features = environment.features;
  lang;

  constructor(private languageService: LanguageService) {
    this.lang = this.languageService.getLanguage();
  }

  /** Action when the user click in the card  */
  onClick(asset) {
    location.hash = "#/details/" + asset.id;
  }
}